import * as React from "react";
import { cn } from "@/lib/cn";

export interface FormSectionProps extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  columns?: 1 | 2;
  children: React.ReactNode;
}

export const FormSection = React.forwardRef<HTMLElement, FormSectionProps>(
  ({ title, description, columns = 1, children, className, ...props }, ref) => (
    <section
      ref={ref}
      className={cn("flex flex-col gap-4", className)}
      {...props}
    >
      {(title || description) && (
        <div className="flex flex-col gap-1">
          {title && (
            <h3 className="font-display text-base font-semibold tracking-tight text-foreground">
              {title}
            </h3>
          )}
          {description && (
            <p className="text-sm text-muted-foreground max-w-prose">{description}</p>
          )}
        </div>
      )}
      <div
        className={cn(
          "grid gap-4",
          columns === 2 ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1",
        )}
      >
        {children}
      </div>
    </section>
  ),
);
FormSection.displayName = "FormSection";
